// services/ApiService.js
const API_URL = process.env.REACT_APP_ENVIRONMENT === 'production' 
  ? 'https://happer-production.francecentral.cloudapp.azure.com/' 
  : process.env.REACT_APP_ENVIRONMENT === 'test' 
  ? 'https://happer-test.francecentral.cloudapp.azure.com/' 
  : 'http://localhost:3001/';

class ApiService {
  async performRequest(url, method, token, body) {
    const response = await fetch(`${API_URL}${url}`, {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      },
      body: body ? JSON.stringify(body) : null
    });

    if (response.status === 401) {
      // Try to refresh token
      const newToken = await this.refreshToken();
      if (newToken) {
        return this.performRequest(url, method, newToken, body);
      } else {
        return null;
      }
    }

    return response.json();
  }

  async get(url, token) {
    return this.performRequest(url, 'GET', token, null);
  }

  async post(url, token, body) {
    return this.performRequest(url, 'POST', token, body);
  }

  async put(url, token, body) {
    return this.performRequest(url, 'PUT', token, body);
  }

  async delete(url, token) {
    return this.performRequest(url, 'DELETE', token, null);
  }

  async refreshToken() {
    const refreshToken = localStorage.getItem('refreshToken');
    const response = await fetch(`${API_URL}api/auth/refresh`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': refreshToken
      }
    });

    const data = await response.json();

    if (data.token) {
      localStorage.setItem('jwtToken', data.token);
      localStorage.setItem('refreshToken', data.refreshToken);
    }

    return data.token;
  }
}

export default new ApiService();
